var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4846 16.4893C16.0083 16.3802 16.3202 15.8321 16.06 15.3647C15.4863 14.3343 14.5825 13.4288 13.4263 12.7388C11.9372 11.8501 10.1127 11.3684 8.23579 11.3684C6.35886 11.3684 4.53437 11.8501 3.0453 12.7388C1.8891 13.4288 0.985284 14.3343 0.411575 15.3647C0.151336 15.8321 0.463243 16.3801 0.986963 16.4893C5.76815 17.4857 10.7034 17.4857 15.4846 16.4893Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.23489,
    cy: 4.73684,
    r: 4.73684
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.4f8b07b4531a367b4eb6f42f0fc22465.svg";
export { ForwardRef as ReactComponent };